import React from 'react';
import { Tooltip, IconButton, TooltipProps } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useStyles } from './style';

interface Props {
  tooltipTitle?: string;
  tooltipPlacement?: TooltipProps['placement'];
  buttonCaption?: string;
  noCaption?: boolean;
}
export function BackButton(props: Props) {
  const { t } = useTranslation();
  const history = useHistory();
  const backButonStyles = useStyles();

  return (
    <Tooltip placement={props.tooltipPlacement} title={props.tooltipTitle || ''}>
      <IconButton
        edge='start'
        size='small'
        className={backButonStyles.button}
        onClick={e => history.go(-1)}
      >
        <ArrowBackIcon />
        {!props.noCaption && (
          <div className={backButonStyles.buttonText}>{props.buttonCaption || t('back')}</div>
        )}
      </IconButton>
    </Tooltip>
  );
}
